import { SubmissionError, getFormValues, reset } from 'redux-form';
import { replace } from 'react-router-redux';

import http from '../../../../shared/http';
import endpoints from '../../../../../config/endpoints';
import { createSelectOptionsFromSysEnums } from '../../../../shared/form-elements/select';

import pick from 'lodash/pick';
import forEach from 'lodash/forEach';
import find from 'lodash/find';

const defaultInitialState = {
	currentLanguage: 'en',
	fields: {
		title: '',
		text: '',
		type: null,
		news_offers: null,
		should_publish: false
	},
	showForm: false
};

const createForm = ({ namespace, stateNodeName }) => {
	// action types
	const FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-success`;
	const FORM_SUBMIT_ERROR = `${namespace}/${stateNodeName}-submit-error`;

	const FETCH_SUGGEST_SUCCESS = `${namespace}/fetch-suggest-success`;
	const FETCH_SUGGEST_ERROR = `${namespace}/fetch-suggest-error`;

	const HIDE_FORM = `${namespace}/${stateNodeName}-hide-form`;
	const TOGGLE_PROGRESS_BAR = `${namespace}/${stateNodeName}-toggle-progress-bar`;
	const RELOAD_PARENT = `${namespace}/${stateNodeName}-reload-parent`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		formSubmit: formData => (dispatch, getState) => {
			const state = getState().newsList;
			const { form } = state;

			const newsOffers = formData && formData.news_offers ? getValues(formData, 'news_offers') : null;
			const newsLocations = formData && formData.news_locations ? getValues(formData, 'news_locations') : null;
			const type = formData && formData.type ? getValues(formData, 'type') : null;

			const fields = pick(formData, Object.keys(form.fields));

			const data = {
				...fields,
				news_offers: newsOffers,
				news_locations: newsLocations,
				type: type && type[0],
				title: fields.title && fields.title.trim(),
				text: fields.text && fields.text.trim()
			};

			const request = http({
				url: endpoints.NEWS.BASE,
				method: 'post',
				actions: [FORM_SUBMIT_SUCCESS, FORM_SUBMIT_ERROR],
				data
			});

			return request(dispatch).then(action => {
				if (action.type === FORM_SUBMIT_SUCCESS) {
					if (action.payload && action.payload.data && action.payload.data.id) {
						dispatch(replace(`/news/edit/${action.payload.data.id}`));
					} else {
						dispatch({ type: RELOAD_PARENT });
					}
				}
				if (action.type === FORM_SUBMIT_ERROR && action.payload.response.status === 400) {
					const responseErrors = action.payload.response.data;
					throw new SubmissionError(prepareFormErrors(responseErrors));
				}
			});
		},

		offersLookups: text => dispatch => {
			const request = http({
				url: `${endpoints.LOOKUPS.OFFERS}?query=${text}`,
				method: 'get',
				actions: [FETCH_SUGGEST_SUCCESS, FETCH_SUGGEST_ERROR]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_SUGGEST_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnums(action.payload.data)
					};
				}
			});
		},

		locationsLookup: text => dispatch => {
			const request = http({
				url: `${endpoints.LOOKUPS.LOCATIONS_WITH_TRAFFIC}?query=${text}`,
				method: 'get',
				actions: [FETCH_SUGGEST_SUCCESS, FETCH_SUGGEST_ERROR]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_SUGGEST_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnums(action.payload.data)
					};
				}
			});
		},

		hideForm: () => dispatch => {
			dispatch(reset('newsListForm'));
			dispatch({ type: HIDE_FORM });
		}
	};

	// reducers
	const reducers = {
		[HIDE_FORM]: state => ({ ...state, form: initialState }),
		[FORM_SUBMIT_SUCCESS]: state => ({ ...state, form: initialState }),
		[FORM_SUBMIT_ERROR]: errorReducerFn,
		[FETCH_SUGGEST_ERROR]: errorReducerFn,
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
		[RELOAD_PARENT]: state => ({ ...state, data: null, showProgressBar: false })
	};

	// selectors
	const selectors = {
		getFormData: state => {
			const { form: { fields, showForm } } = state.newsList;

			const typesSelectOptions = createSelectOptionsFromSysEnums(state.root.lists['news-types']);

			const currentFormValues = getFormValues('newsListForm')(state);
			const isShouldPublishChecked = currentFormValues && currentFormValues.should_publish;

			return {
				selectOptions: {
					types: typesSelectOptions
				},
				initialValues: {
					...fields,
					type: typesSelectOptions && [find(typesSelectOptions, { value: 'custom' })]
				},
				showForm,
				isShouldPublishChecked
			};
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

// functions
const prepareFormErrors = errors => {
	const validationsErrors = {};
	forEach(errors, value => {
		const key = value.dataPath.slice(1);
		validationsErrors[key] = value.message;
	});
	return validationsErrors;
};

const errorReducerFn = (state, action) => {
	if (action.payload.response.status !== 400) {
		return { ...state, error: true, showProgressBar: false };
	}
	return state;
};

const getValues = (data, key) => {
	return data && data[key] && data[key].length && data[key].map(option => option.value);
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/news/components/form/small/index.js